import { createContext, useContext } from "react";

export interface AnchorLink {
    id: string;
    label: string;
    uid: string;
}

export interface AnchorContextModel {
    addOrUpdateLink: (link: AnchorLink) => void;
    links: AnchorLink[];
    removeLink: (uid: AnchorLink["uid"]) => void;
}

export const AnchorContext = createContext<AnchorContextModel>({} as any);
export const useAnchorContext = () => useContext(AnchorContext);
